import * as React from 'react';
import { useSystemMessage_unstable } from './useSystemMessage';
import { renderSystemMessage_unstable } from './renderSystemMessage';
import { useSystemMessageStyles_unstable } from './useSystemMessageStyles.styles';
import type { SystemMessageProps } from './SystemMessage.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

// SystemMessage component - TODO: add more docs
export const SystemMessage: ForwardRefComponent<SystemMessageProps> = React.forwardRef((props, ref) => {
  const state = useSystemMessage_unstable(props, ref);

  useSystemMessageStyles_unstable(state);
  return renderSystemMessage_unstable(state);
});

SystemMessage.displayName = 'SystemMessage';
